export default {
  STATIC_DOCUMENT: 'STATIC_DOCUMENT',
  LIVE_DOCUMENT: 'LIVE_DOCUMENT',
  ANY: 'ANY',
};
